import React from "react";
import FooterIcon from "../../images/Icons/FooterIcon";
import s from "./Footer.module.scss";

const Footer = () => {
  return (
    <div className={s.footer}>
      <span className={s.footerLabel}>2021 &copy; Eiteck </span>
    </div>
  );
};

export default Footer;
